<template>
  <div @click="handleWhiteBackgroundOnClick($event)" id="mediaList" :class="['select-btn-testing', {'visible': isMediaListVisibleProp, 'vertical': (mediaOrientation === 'vertical')}]" refs="mediaList">
    <el-container class="content-aside">
      <el-main :class="['cpl-main', {'audio-picker': asAudioPicker }]">
        <!-- Media Filters -->
        <div class="options">
          <el-row :gutter="20" class="mediaList-options-content">
            <!-- Media Type Filter -->
            <el-col :span="7" class="filter-col">
              <el-tooltip v-if="showImageFilterOption" :popper-class="'custom-tooltip-popper-filters'" :show-arrow="false" effect="light" class="item" :content="$t('filters.images')" placement="bottom">
                <el-button @click="mediaTypeFilterOnChange(mediaTypes.img)"
                  :class="['cstm-icon-btn-medium', 'image', 'filter', {'is-selected': mediaFilter.selectedMediaType.indexOf(mediaTypes.img) >= 0 }]">
                </el-button>
              </el-tooltip>

              <el-tooltip v-if="showVideoFilterOption" :popper-class="'custom-tooltip-popper-filters'" :show-arrow="false" effect="light" class="item" :content="$t('filters.videos')" placement="bottom">
                <el-button @click="mediaTypeFilterOnChange(mediaTypes.video)"
                  :class="['cstm-icon-btn-medium', 'video', 'filter', {'is-selected': mediaFilter.selectedMediaType.indexOf(mediaTypes.video) >= 0}]">
                </el-button>
              </el-tooltip>

              <el-tooltip v-if="showProjectFilterOption && [accessorComponentsOptions.SCHEDULE_EVENT_ITEM].indexOf(accessorComponent) >= 0" :popper-class="'custom-tooltip-popper-filters'" :show-arrow="false" effect="light" class="item" :content="$t('filters.projectsOrPdf')" placement="bottom">
                <el-button @click="mediaTypeFilterOnChange(mediaTypes.project)"
                  :class="['cstm-icon-btn-medium', 'project', 'filter', {'is-selected': mediaFilter.selectedMediaType.indexOf(mediaTypes.project) >= 0}]">
                </el-button>
              </el-tooltip>

              <el-tooltip v-if="showProjectFilterOption && [accessorComponentsOptions.CREATE_PROJECT_TEMPLATES, accessorComponentsOptions.EDIT_PROJECT_TEMPLATE].indexOf(accessorComponent) >= 0" :popper-class="'custom-tooltip-popper-filters'" :show-arrow="false" effect="light" class="item" :content="$t('filters.elementiProject')" placement="bottom">
                <el-button @click="mediaTypeFilterOnChange(mediaTypes.project)"
                  :class="['cstm-icon-btn-medium', 'project-elementi', 'filter', {'is-selected': mediaFilter.selectedMediaType.indexOf(mediaTypes.project) >= 0}]">
                </el-button>
              </el-tooltip>

              <el-tooltip v-if="showAudioFilterOption" :popper-class="'custom-tooltip-popper-filters'" :show-arrow="false" effect="light" class="item" :content="$t('filters.audio')" placement="bottom">
                <el-button @click="mediaTypeFilterOnChange(mediaTypes.audio)"
                  :class="['cstm-icon-btn-medium', 'audio', 'filter', {'is-selected': mediaFilter.selectedMediaType.indexOf(mediaTypes.audio) >= 0}]">
                </el-button>
              </el-tooltip>
            </el-col>

            <!-- Media Search Text -->
            <el-col :span="16" class="search-text-col">
              <div class="search">
                <el-input
                  id="media-list-search"
                  v-if="showSearchInput"
                  :model-value="searchTextVal"
                  @update:model-value="newValue => searchTextVal = newValue"
                  :placeholder="$t('label.search')"
                  @blur="mediaFilterTextInputConfirm"
                  ref="searchTextInput">
                </el-input>
                <el-button class="btn-search" v-else @click="mediaFilterShowTextInput"></el-button>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- Media Tags filter -->
        <tag-slider v-if="$currentUser.hasGroupExtended()"
          :accessorComponentProp="'mediaListInModal'"
          :refreshTagSliderProp="refreshTagSlider"
          :ledTagItemProp="tagSliderledTagItem"
          @tag-slider-change="handleTagSliderChange($event)">
        </tag-slider>

        <!-- PopIds filter -->
        <pop-ids-slider v-if="showPopIdsSliderFilter"
          :accessorComponentProp="'mediaListInModal'"
          :refreshTagSliderProp="refreshTagSlider"
          :ledTagItemProp="tagSliderledTagItem"
          @popId-slider-change="handlePopIdsSliderChange($event)">
        </pop-ids-slider>

        <!-- Media cards container -->
        <el-row id="mediaListItemContainer" :gutter="20"
          :class="['media-row', {'more-items': mediaList.nextFetch && mediaList.nextFetch.moreItems, 'audio-picker hide-scrollbar': asAudioPicker,}]">
          <div :class="['media-cards-container', accessorComponent, 'clear-media-selection-if-clicked', {'vertical': (mediaOrientation === 'vertical')}]">
            <!-- Add new media action card -->
            <template v-if="enableMediaUpload && mediaFilter.selectedMediaType.indexOf(mediaTypes.project) < 0">
              <el-col id="new-media-upload" :span="asAudioPicker ? 24 : 4"
                :class="['media-item', 'uploader',
                  {'audio-card': asAudioPicker,
                  'vertical': mediaOrientation === 'vertical' && !asAudioPicker}]">
                <div class="content">
                  <div :class="['media-preview-fixed flex items-center justify-center', 'new-media-upload-action', {'audio-card': asAudioPicker}]">
                    <el-icon color="#fff" class="icon no-inherit">
                      <UploadFilled />
                    </el-icon>
                  </div>
                </div>
                <div @click="updateFileUploaderConfig({ fileUploadCardClick: true })" :class="['preview-content-cover']"></div>
              </el-col>
            </template>

            <!-- Media cards -->
            <el-col v-for="(item, indx) in mediaList.itemsToShow" :key="indx"
              :class="['media-item clear-media-selection-if-clicked',
                {'audio-card': asAudioPicker,
                'selected': item._edit.selected,
                'vertical': mediaOrientation === 'vertical' && !asAudioPicker,
                'has-opacity': (mediaSelection.length > 0 && !item._edit.selected),
                'not-visible': item._edit.notVisible,
                'disabled-media-item': item.disabled}]"
                :data-filename="item.name"
                :span="asAudioPicker ? 24 : 8">

              <div class="content clear-media-selection-if-clicked">
                <div :class="['media-preview-fixed',
                  {'disabled-media-item': item.disabled,
                  'checkboard-background': item.hasOwnProperty('preview') && item.preview.type === 'img'}]">

                  <template v-if="item.hasOwnProperty('preview') && item.preview !== null">
                    <!-- For Not IE Browsers (IMAGE)-->
                    <img v-if="item.preview.hasOwnProperty('type') && item.preview.type === 'img' && !isIEBrowser"
                      :src="$utils.filterMediaPreviewUrl(item.preview.url)"
                      class="object-fit_cover_center"/>
                    <!-- For IE Browsers (IMAGE)-->
                    <div v-if="item.preview.hasOwnProperty('type') && item.preview.type === 'img' && isIEBrowser"
                      class="object-fit_fix_on_ie"
                      :style="{'backgroundImage': `url(${item.preview.url})`}">
                    </div>

                    <!-- For Not IE Browsers (LOGO)-->
                    <img v-if="item.preview.hasOwnProperty('type') && item.preview.type === 'logo' && isIEBrowser"
                      :src="$utils.filterMediaPreviewUrl(item.preview.url)"
                      class="object-fit_cover_center"/>
                    <!-- For IE Browsers (LOGO)-->
                    <div v-if="item.preview.hasOwnProperty('type') && item.preview.type === 'logo' && isIEBrowser"
                      class="object-fit_fix_on_ie"
                      :style="{'backgroundImage': `url(${item.preview.url})`}">
                    </div>

                    <!-- Project Preview -->
                    <template v-if="(item.preview.type && item.preview.type === 'svg') && (item.type && [mediaTypes.audio, mediaTypes.audioPlaylist].indexOf(item.type) < 0)">
                      <iframe :id="`mediaProjectFile_${item.resourceId}`"
                        :src="$utils.filterMediaPreviewUrl(item.preview.url)"
                        :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${item._edit.uid}`]">
                      </iframe>
                    </template>

                    <div v-if="item.preview.hasOwnProperty('type') && item.type === 'video'"
                      @click="handleVideoPlayIconClick(item.videopreviews)"
                      class="video-play-icon">
                    </div>
                  </template>

                  <template v-if="(item.hasOwnProperty('preview') && item.preview === null) || (item.type === undefined)">
                    <div class="no-preview">
                      <div class="desc">
                        <el-icon class="el-icon-warning"><WarningFilled /></el-icon>
                        <p>{{$t('label.previewUnavailable')}}</p>
                      </div>
                    </div>
                  </template>

                  <!-- For Audio Preview -->
                  <template v-if="(item.type && [mediaTypes.audio, mediaTypes.audioPlaylist].indexOf(item.type) >= 0)">
                    <div :class="['audio-preview', item.type, {'has-status': item.preview.status}]">
                      <el-button v-if="(item.type && [mediaTypes.audio].indexOf(item.type) >= 0)" class="cstm-icon-btn-medium audio_note_white_bacgkround"></el-button>

                      <iframe :id="`mediaProjectFile_${item.resourceId}`"
                        :src="$utils.filterMediaPreviewUrl(item.preview.url)"
                        :data-src="$utils.trimDataSrc(item.preview.url)"
                        :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', 'audio-iframe', `media-preview-${item._edit.uid}`]">
                      </iframe>
                    </div>
                  </template>

                  <div v-if="asAudioPicker" :class="['audio-details']">
                    <template v-if="item.metadata && (item.metadata.title || item.metadata.artist)">
                      <div v-if="item.metadata && item.metadata.title" class="title">{{item.metadata.title}}</div>
                      <div v-if="item.metadata && item.metadata.artist" class="artist">{{item.metadata.artist}}</div>
                    </template>
                    <template v-else>
                      <div class="title">{{item.name}}</div>
                    </template>
                  </div>
                </div>
              </div>

              <el-tooltip :key="indx"
                :popper-class="'custom-tooltip-popper-media-list'"
                :show-arrow="false" effect="light" class="item"
                :disabled="!mediaFilter.selectedMediaType.includes('all') && [mediaTypes.audio, mediaTypes.audioPlaylist].includes(item.type)"
                :content="item.name"
                placement="bottom">

                <div @click="handleMediaCardClick($event, item, indx)"
                  :class="['preview-content-cover', {'disabled-media-item': (item.disabled)}]">
                </div>
              </el-tooltip>
            </el-col>
          </div>

          <div v-if="!mediaList.nextFetch.moreItems" class="media-list-items-bottom-space"></div>
        </el-row>

        <!-- Media selection actions -->
        <div v-if="multiSelect && mediaList.itemsToShow.length" class="media-selection-action">
          <el-button @click="resetMediaSelection(true)" class="cstm-btn-grey width-auto cancel-selection-btn">{{$t('label.cancel')}}</el-button>
          <el-button @click="sendMediaSelectionToParent(mediaSelection)" class="cstm-btn-gradient width-auto send-selection-btn">{{$t('label.select')}}</el-button>
        </div>
      </el-main>
    </el-container>

    <!-- Play Video Dialog -->
    <el-dialog id="playVideoDialog" v-if="playVideo.dialog"
      :visible="playVideo.dialog" :modal="false" :close-on-click-modal="false"
      @close="playVideo.dialog = false" width="40%">
        <video autoplay controls>
          <source v-for="(videopreview, key) in playVideo.videopreviews"
            :key="key"
            :src="$utils.filterMediaPreviewUrl(videopreview.url)"
            :type="videopreview.format"
          />
        </video>
    </el-dialog>
  </div>
</template>

<script src="./media-list.js"></script>
<style lang="scss" src="./media-list.scss"></style>
